<template>
  <span>
    <Legenda titulo="Cobertura média estoque" legenda="É a média das Coberturas de Estoque dos produtos que possuem Projeção de Vendas.">
      <span
        @click="dialog_dias_estoque = true"
        style="cursor: help"
      >
        {{ Helpers.formatarValorComCasas(item.qtde_dias_estoque, 1) }} dias
      </span>
    </Legenda>

    <SysDialog v-model="dialog_dias_estoque" :largura="900" ocultarAcoes>
      <template #titulo>
        <div class="w-700">
          <p class="ma-0">Cobertura de estoque do fornecedor</p>
          <p class="ma-0 pl-2px mt-n3 font-13 text-gray-900 text-truncate">{{ `${item.id} - ${item.razao_social}` }}</p>
        </div>

        <v-spacer />

        <v-btn icon @click="dialog_dias_estoque = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>

      <div class="d-flex align-center mt-n2">
        <v-icon :size="20">mdi-format-list-bulleted</v-icon>
        <span class="font-18 font-weight-medium ml-1 text-gray-1000">Produtos</span>

        <v-spacer />

        <v-text-field
            v-model="search"
            outlined
            dense
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
            style="max-width: 350px"
        />

        <v-btn @click="exportarParaExcel()" color="primary" class="ml-2">
          <v-icon class="pr-1">$Excel</v-icon>
          Exportar
        </v-btn>
      </div>

      <sys-data-table
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 265"
        :item-height="40"
        hide-default-footer
        class="mt-4"
        :search="search"
      >
        <template #item.descricao_produto="{ item }">
          <DetalhamentoProduto :produto="{ id_grupo: GRUPO_COMPRAS, id_filial: FILIAL_COMPRAS, id_produto: item.idproduto }" style="display: inline;"/>
          {{ item.descricao_produto }}
        </template>
        <template #item.estoque="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.consumo_medio_mensal="{ value }">{{ Helpers.formatarValor(value) }}</template>
        <template #item.cobertura_estoque_dias="{ item }">
          <span v-if="item.consumo_medio_mensal > 0">{{ Helpers.formatarValorComCasas(item.cobertura_estoque_dias, 1) }} dias</span>
          <span v-else>-</span>
        </template>
      </sys-data-table>
    </SysDialog>
  </span>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import Responsividade from '@/helpers/ResponsiveHeight';
import { buscarProdutosFornecedorDiasEstoque } from "./DiasEstoqueApi";
import { mapGetters } from 'vuex';
import DetalhamentoProduto from '@/components/produto/detalhes/Index';
import Legenda from '../../../produto/detalhes/Legenda.vue';
import $axios from "@/api/api";
import RelatorioApi from "@/api/relatorio.js"

export default {
  mixins: [Responsividade],
  components: { SysDialog, DetalhamentoProduto, Legenda },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog_dias_estoque: false,
      headers: [
        { text: 'Id Produto', value: 'idproduto' },
        { text: 'Descrição Produto', value: 'descricao_produto' },
        { text: 'Estoque', value: 'estoque' },
        { text: 'Projeção de vendas', value: 'consumo_medio_mensal' },
        { text: 'Cobertura Estoque', value: 'cobertura_estoque_dias' },
      ],
      search: "",
      desserts: []
    }
  },
  computed: {
    ...mapGetters({
      GRUPO_COMPRAS: "usuario/getGrupoCompras",
      FILIAL_COMPRAS: "usuario/getFilialCompras"
    })
  },
  watch: {
    dialog_dias_estoque(valor) {
      if (valor) this.buscarDadosDoFornecedo();
    }
  },
  methods: {
    buscarDadosDoFornecedo() {
      const parametros = {
        idgrupo: this.GRUPO_COMPRAS,
        idfornecedor: this.item.id
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarProdutosFornecedorDiasEstoque(parametros)
        .then(dados => this.desserts = dados)
        .catch(() => this.Helpers.logout())
      );
    },

    exportarParaExcel() {
      const url = '/relatorios/cobertura-estoque-produtos'
      const params = `?idgrupo=${this.GRUPO_COMPRAS}&idfornecedor=${this.item.id}`;

      window.open($axios.defaults.baseURL + url + params, "_blank");
    },
  },
}
</script>

<style>

</style>
